import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { Logger } from '@app/core';

const log = new Logger('NotifierService');
type Event = 'none' | 'click' | 'change';

/**
 * @description:
 * source: nombre desde donde se realiza la notificación.
 * eventTriggered: evento que se utilizo para desencadenar la notificación.
 * data: datos que se quieren notificar.
 *
 * @example:
 * {
 *  source: 'task';
 *  eventTriggered: 'click';
 *  data: 'Datos de la notificación';
 * }
 *
 * @interface Notification
 */
interface Notification {
  source: string;
  eventTriggered: Event;
  action: string;
  instance?: string;
  data?: any;
  modify?: boolean;
}

@Injectable()
export class NotifierService {
  private subject = new Subject<any>();

  /**
   * Genera las notificaciones.
   *
   * @param {Notification} notification
   * @memberof NotifierService
   */
  set(notification: Notification) {
    // log.debug('New notification: ', notification);
    this.subject.next(notification);
  }

  /**
   * Envia las notificaciones.
   *
   * @returns {Observable<Notification>}
   * @memberof NotifierService
   */
  get(): Observable<Notification> {
    return this.subject.asObservable();
  }

  /**
   * Limpia todas las notificaciones realizadas.
   *
   * @memberof TaskNotifierService
   */
  clean() {
    this.subject.next();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/notifier.service.ts